import styled, { css } from 'styled-components';

export const ParticipantItemContainer = styled.div<{ $isSpeaking: boolean }>`
    box-sizing: border-box;
    border-radius: 8px;
    overflow: hidden;
    position: relative;

    /* показываем меню три точки при ховере на плитку или когда меню открыто */
    &:hover .moderation-menu-button,
    :has([data-state='open']) .moderation-menu-button {
        opacity: 1;
        width: 32px;
    }

    /* для маленького варианта меню */
    &:hover .moderation-menu-button[data-variant='tile-small'],
    :has([data-state='open']) .moderation-menu-button[data-variant='tile-small'] {
        width: 24px;
    }

    ${({ $isSpeaking }) =>
        $isSpeaking &&
        css`
            &:after {
                border: 3px solid ${(props) => props.theme.root.colors.primary.hover};
                border-radius: 8px;
                box-sizing: border-box;
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
            }
        `}
`;

export const TileIconsContainer = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 6;
`;

export const SpeakerIndicator = styled.div<{ $isSmall: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    transform: translate(8px, -8px);
    width: ${(props) => (props.$isSmall ? 24 : 32)}px;
    height: ${(props) => (props.$isSmall ? 24 : 32)}px;
    border-radius: 50%;
    background: ${(props) => props.theme.root.colors.primary.default};
`;
